module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/interselect-9317aaf413f6645bd17935920bd3c2e9.svg";